<template>
  <layout-default>
    <div id="patient" class="v-inner--wrap">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <inner-drawer :routes="bhUsersRoutes">
        <template v-slot:header>
          <bh-user-card :bh-user="bhUser"/>
        </template>
      </inner-drawer>
      <inner-content />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InnerDrawer from "@/components/InnerDrawer.vue"
import InnerContent from "@/components/InnerContent.vue"
import BhUserCard from "@/components/bhUsers/BhUserCard.vue"
import LayoutDefault from '../layouts/LayoutDefault.vue'

import { childrenPaths as bhUsersRoutes } from "@/router/paths/bhUsersPaths"

export default {
  name: 'BhUser',
  components: {
    InnerDrawer,
    InnerContent,
    BhUserCard,
    LayoutDefault
  },
  data () {
    return {
      bhUsersRoutes
    }
  },
  mounted () {
    this.getBhUser(this.bhUserId)
  },
  computed: {
    ...mapState('bhUsersStates', [
      'bhUser',
      'loading'
    ]),
    bhUserId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('bhUsersStates', [
      'getBhUser'
    ])
  },
  watch: {
    $route (to, from) {
      // get new current bhuser data when bhuser id changed
      if (to.params?.id !== undefined && from.params?.id !== to.params?.id) {
        this.getBhUser(to.params.id)
      }
    }
  }
}
</script>
